var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCartIc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.185 6.1925C18.1084 6.08173 18.006 5.99119 17.8867 5.92864C17.7674 5.86608 17.6347 5.83338 17.5 5.83334H6.11085L5.14919 3.525C5.02309 3.22102 4.80958 2.96133 4.53571 2.77885C4.26184 2.59636 3.93995 2.49932 3.61085 2.5H1.66669V4.16667H3.61085L7.56419 13.6542C7.62751 13.806 7.73433 13.9356 7.87121 14.0268C8.00808 14.118 8.16888 14.1667 8.33335 14.1667H15C15.3475 14.1667 15.6584 13.9508 15.7809 13.6267L18.2809 6.96C18.3281 6.83385 18.3441 6.69813 18.3274 6.56446C18.3107 6.43079 18.2618 6.30316 18.185 6.1925Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.75 17.5C9.44036 17.5 10 16.9404 10 16.25C10 15.5596 9.44036 15 8.75 15C8.05964 15 7.5 15.5596 7.5 16.25C7.5 16.9404 8.05964 17.5 8.75 17.5Z",
    fill: "#333333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5833 17.5C15.2737 17.5 15.8333 16.9404 15.8333 16.25C15.8333 15.5596 15.2737 15 14.5833 15C13.893 15 13.3333 15.5596 13.3333 16.25C13.3333 16.9404 13.893 17.5 14.5833 17.5Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartIc);
export default __webpack_public_path__ + "static/media/cart_ic.af0148d818d551656b866fcb716ba9d2.svg";
export { ForwardRef as ReactComponent };